module.exports = __webpack_public_path__ + "static/media/amenity_lobby_fireplace.a20d5ed7.jpg";